import { useState, useEffect } from 'react';

export const maskName = (name = "") => {
    if (name.length <= 4) return name;
    if (name === "Rakesh Panchal") {
        return name;
    }
    const firstTwo = name.slice(0, 2);
    const lastTwo = name.slice(-2);
    const maskedMiddle = "*".repeat(name.length - 4);

    return `${firstTwo}${maskedMiddle}${lastTwo}`;
};

export const useVisitorData = () => {
    const [visitorData, setVisitorData] = useState(null);

    useEffect(() => {
        const gatherData = async () => {
            // 1. Browser Details (Instantly available)
            const browserInfo = {
                browser: window.navigator.userAgent,
                os: window.navigator.platform || 'Unknown',
                language: window.navigator.language || 'Unknown',
                screenResolution: `${window.screen.width}x${window.screen.height}`
            };

            // 2. IP Address
            let ip = 'Unavailable';
            try {
                const res = await fetch('https://api.ipify.org?format=json');
                const ipData = await res.json();
                ip = ipData.ip;
            } catch (err) {
                console.error("IP Fetch Error:", err);
            }

            // 3. Geolocation & Reverse Geocoding (Physical Address)
            let locationInfo = {
                latitude: '',
                longitude: '',
                currentAddress: ''
            };

            const getPosition = () => new Promise(resolve => {
                if (!navigator.geolocation) return resolve(null);
                navigator.geolocation.getCurrentPosition(
                    pos => resolve({ lat: pos.coords.latitude, lng: pos.coords.longitude }),
                    err => resolve(null) // User denied permission
                );
            });

            const coords = await getPosition();

            // If user allowed location, fetch the physical address
            if (coords) {
                locationInfo.latitude = coords.lat;
                locationInfo.longitude = coords.lng;
                try {
                    const geoRes = await fetch(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${coords.lat}&lon=${coords.lng}`);
                    const geoData = await geoRes.json();
                    locationInfo.currentAddress = geoData.display_name || 'Address not found';
                } catch (err) {
                    locationInfo.currentAddress = 'Address not found';
                }
            }

            // 4. Combine all gathered data into exactly ONE state update
            setVisitorData({
                ip,
                ...browserInfo,
                ...locationInfo
            });
        };

        gatherData();
    }, []);

    console.log("visitorData", visitorData)

    return visitorData; // Returns null while loading, then returns the full object
};

// Generates the encoded WhatsApp link with Title, Description, Image, and Link
export const getWhatsAppLink = (item) => {
    const text = `*${item.title}*\n\n${item.decription ? item.decription + '\n\n' : ''}Image: ${item.item_image_url}\n\nMore info: ${item.whatsup_link + item.id}`;
    return `https://api.whatsapp.com/send?text=${encodeURIComponent(text)}`;
};

export const getFacebookLink = (item) => {
    const sharedUrl = item.whatsup_link + item.id;

    // Note: Facebook pulls the image and text entirely from your SEO Meta Tags!
    return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(sharedUrl)}`;
};

export const getTwitterLink = (item) => {
    const sharedUrl = item.whatsup_link + item.id; // The link to the actual page

    // Truncate description to keep the tweet within character limits
    const shortDesc = item.decription ? item.decription.substring(0, 100) + '... ' : '';
    const text = `${item.title}\n\n${shortDesc}`;

    return `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(sharedUrl)}`;
};

export const getLinkedInLink = (item) => {
    const sharedUrl = item.whatsup_link + item.id;

    // Note: LinkedIn pulls the image and text entirely from your SEO Meta Tags!
    return `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(sharedUrl)}`;
};